import * as React from "react";

export const SubJudulSkill = () => {
  
      return (
            <>
                  <div>
                        <h5 className="font-normal text-center text-[0.7rem] md:text-[1.1rem] lg:text-[1.3rem] xl:text-2xl 2xl:text-3xl">
                              Faktor Pertimbangan Untuk Bapak/Ibu
                        </h5>
                  </div>
            </>
      )

}